module.exports = __webpack_public_path__ + "img/pro.88c86ce0.png";